import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../config";
import { getAccessToken } from "../LoginForm/Auth/auth";

const getTypeNameFromFeature = (feature) => {
    if (!feature?.id) return "";
    const layerName = feature.id.split(".")[0];
    return `elektro:${layerName}`;
};

export const deleteFeature = async ({ feature, setIsDeleted, setCurrentDrawing }) => {
    if (!feature?.id) {
        toast.error("Objekat nema ID za brisanje.");
        return;
    }

    setCurrentDrawing(feature);

    const typeName = getTypeNameFromFeature(feature);
    const wfsUrl = `${BASE_URL}/geoserver/elektro/ows`;
    const token = getAccessToken();

    const deleteXML = `<?xml version="1.0" encoding="UTF-8"?>
    <wfs:Transaction service="WFS" version="1.0.0"
        xmlns:wfs="http://www.opengis.net/wfs"
        xmlns:gml="http://www.opengis.net/gml"
        xmlns:ogc="http://www.opengis.net/ogc">
        <wfs:Delete typeName="${typeName}">
            <ogc:Filter>
                <ogc:FeatureId fid="${feature.id}" />
            </ogc:Filter>
        </wfs:Delete>
    </wfs:Transaction>`;

    try {
        const response = await axios.post(wfsUrl, deleteXML, {
            headers: {
                "Content-Type": "application/xml",
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 200) {
            toast.success(`Objekat ${feature.id} je uspješno obrisan.`);
            setIsDeleted(true);
        }
    } catch (error) {
        console.error("Greška pri brisanju:", error.response?.data || error.message);
        toast.error("Greška pri brisanju objekta.");
    }
};

export const archiveFeature = async ({ feature, setIsDeleted, setCurrentDrawing }) => {
    if (!feature?.id) {
        toast.error("Objekat nema ID za arhiviranje.");
        return;
    }

    setCurrentDrawing(feature);

    const typeName = getTypeNameFromFeature(feature);
    const wfsUrl = `${BASE_URL}/geoserver/elektro/ows`;
    const today = new Date().toISOString().split("T")[0];
    const token = getAccessToken();

    const updateXML = `<?xml version="1.0" encoding="UTF-8"?>
    <wfs:Transaction service="WFS" version="1.0.0"
        xmlns:wfs="http://www.opengis.net/wfs"
        xmlns:gml="http://www.opengis.net/gml"
        xmlns:ogc="http://www.opengis.net/ogc">
        <wfs:Update typeName="${typeName}">
            <wfs:Property>
                <wfs:Name>datum_prestanka</wfs:Name>
                <wfs:Value>${today}</wfs:Value>
            </wfs:Property>
            <ogc:Filter>
                <ogc:FeatureId fid="${feature.id}" />
            </ogc:Filter>
        </wfs:Update>
    </wfs:Transaction>`;

    try {
        const response = await axios.post(wfsUrl, updateXML, {
            headers: {
                "Content-Type": "application/xml",
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 200) {
            toast.success(`Objekat ${feature.id} je uspješno arhiviran.`);
            setIsDeleted(true);
        }
    } catch (error) {
        console.error("Greška pri arhiviranju:", error.response?.data || error.message);
        toast.error("Greška pri arhiviranju objekta.");
    }
};